
import DefaultModel from './../../../../../zviz2/zviz/model';
import ModelCollection from './../../../../../zviz2/zviz/modelcollection';
import Vector2 from './../../../../../zviz2/zviz/math/vector2';
import state from './../../../../../zviz2/zviz/state';
import {extend} from './../../../../../zviz2/zviz/functions';

import {default as TopoJSONFeature} from './../../../../../zviz2/vendor/topojson/src/feature';

import {data as mapdata} from './data';
import {applyProjection, addToBoundingBox, createPath} from './../functions';

class GeoModel extends DefaultModel{


    constructor(name=null, settings={}){

        // let filterModel = ModelCollection.getModel(null, 'filter');

        // settings = extend(settings, {
        //     listeners: [
        //         (model) => ( model.addListener(state, [model, model.setUserZoom], 'map.zoomScale') )
        //     ]
        // });

        super(name, settings);

        this.globalBounds = [{x:0, y:0}, {x:0, y:0}];
        this.regionalBBoxes = new Map();
        this.subRegionalBBoxes = new Map();
        this.countryData = new Map();
        this.countryPaths = [];
        this.countryOrder = [];

        this.scale = 1;
        this.position = new Vector2();
        this.boundingBox = [{x:0, y: 0}, {x: 0, y: 0}];
        
        // this.filterModel = filterModel;

        this.update();

    }


    // setDetails(){
        
    //     for(let id of Object.keys(mapdata.details)){
    //         let d = mapdata.details[id];

    //         if(!d.country){
    //             continue;
    //         }

    //         let subregion = this.filterModel.getParentValue('country', d.country);
    //         if(subregion && subregion.length>0){
    //             mapdata.details[id].subregion = subregion[0];
    //             let region = this.filterModel.getParentValue('subregion', subregion);
    //             if(region && region.length>0){
    //                 mapdata.details[id].region = region[0];
    //             }
    //         }
    //     }

    //     console.log(JSON.stringify(mapdata.details));
    // }

    fetchData(){
        this.setCountryData();
        this.setCountryPaths();

        this.setData(this.countryData);

    }

    setCountryData(){
        this.globalBounds = [{x:0, y:0}, {x:0, y:0}];
        this.regionalBBoxes = new Map();
        this.subRegionalBBoxes = new Map();

        this.countryData = new Map();
        this.countryOrder = [];

        for(let id of Object.keys(mapdata.details)){
            let d = mapdata.details[id];
            d.size = 0;
            if(d.bbox.length == 4){

                let b1 = applyProjection([d.bbox[2], d.bbox[1]]);
                let b2 = applyProjection([d.bbox[0], d.bbox[3]]);
                
                d.localBBox = [{x: b1[0], y:b1[1]}, {x: b2[0], y: b2[1]}];
                d.size = Math.abs((b2[0]+200) - (b1[0]+200)) * Math.abs((b2[1]+100) - (b1[0] + 100));
            }else{
                d.localBBox = [{x: 0, y:0}, {x: 0, y: 0}];
            }
            if(d.centroid && d.centroid.length == 2){
                d.localCentroid = applyProjection([d.centroid[1], d.centroid[0]]);
            }else{
                d.localCentroid = [0.5*(d.localBBox[1].x + d.localBBox[0].x), 
                        0.5*(d.localBBox[1].y - d.localBBox[0].y)]; 
            }
            this.countryData.set(d.id3, d);

            if(d.region && d.region != ''){
                let rbox = [];
                if(this.regionalBBoxes.has(d.region)){
                    rbox = this.regionalBBoxes.get(d.region); 
                }else{
                    rbox = [{x:0, y:0}, {x:0, y:0}];
                }
                addToBoundingBox(rbox, d.localBBox);
                this.regionalBBoxes.set(d.region, rbox);
            }
            if(d.subregion && d.subregion != ''){
                let rbox = [];
                if(this.subRegionalBBoxes.has(d.subregion)){
                    rbox = this.subRegionalBBoxes.get(d.subregion); 
                }else{
                    rbox = [{x:0, y:0}, {x:0, y:0}];
                }
                addToBoundingBox(rbox, d.localBBox);
                this.subRegionalBBoxes.set(d.subregion, rbox);
            }

            addToBoundingBox(this.globalBounds, d.localBBox);

        }

    }

    setCountryPaths(){

        let countries = TopoJSONFeature(mapdata.topojson, 
                mapdata.topojson.objects.countries);

        this.countryPaths = [];

        for(let i = 0; i < countries.features.length; i++){
            let c = countries.features[i];

            if(c.id == 'ATA'){  // do not render antarctica
                continue;
            }
            if(this.countryData.has(c.id)){
                let data = this.countryData.get(c.id);
                c.size = data.size;
            }else{
                c.size = 0;
            }

            c.path = createPath(c.geometry.coordinates);
            
            this.countryPaths.push(c);
        }

        this.countryPaths.sort(function(a, b){
            return (b.size - a.size);
        });

    }

    isInSelection(d, selected){

        if(! selected){
            return true;
        }
        if(! (selected instanceof Array)){
            selected = [ selected ];
        }

        if(typeof d == 'string'){
            d = this.countryData.get(d);
        }
        if(! d){
            return false;
        }

        for(let sel of selected){
            let type = sel.type;
            if((sel.value instanceof Array) && sel.value.indexOf(d[type]) != -1){
                return true;
            }else if( sel.value == d[type]){
                return true;
            }
        }

        return false;
        
    }

    setZoom(scale, position, boundingBox){
        if(scale != this.scale || this.position.x != position.x || this.position.y != position.y){
            this.scale = scale;
            this.position = position;

            this.boundingBox = [{x:boundingBox[0].x, y: boundingBox[0].y}, 
                    {x:boundingBox[1].x, y: boundingBox[1].y}];

            this.trigger();
        }
    }

    getBounds(values){
        let globalBounds = [ {x: 0, y: 0}, {x: 0, y: 0} ];
        let found = false;
        for(let [id, d] of this.countryData){
            if(this.isInSelection(d, values)){
                found = true;
                if(d.localBBox){
                    addToBoundingBox(globalBounds, d.localBBox);
                }
            }
        }

        return globalBounds;
    }

    getGeoData(value, dimension){

        let bbox = [new Vector2(), new Vector2()];
        let ids = [];
        let centroid = new Vector2();
        let name = value;
        for(let [k, country] of this.countryData){
            if((dimension == 'region' && country.region == value) ||
                    (dimension == 'subregion' && country.subregion == value) ||
                    (dimension == 'id3' && country.id3 == value) ||
                    (dimension == 'country' &&  country.country == value)){
                if(! (country.localBBox[0].x == 0 && country.localBBox[1].x && 
                        country.localBBox[0].y == 0 && country.localBBox[1].y == 0)){

                    bbox = addToBoundingBox(bbox, country.localBBox);
                    
                }

                if(country.id3 == value || country.country == value){
                    name = country.country;
                }else if(country.region == value){
                    name = country.region;
                }
                
                ids.push(country.id3);

                centroid.x = country.localCentroid[0];
                centroid.y = country.localCentroid[1];
            }
        }
        if(ids.length == 0){
            return null;
        }


        let scale = this.scale; 
        let pos = this.position;

        bbox[0].multiply(scale).add(pos);
        bbox[1].multiply(scale).add(pos);
        if(ids.length > 1){
            centroid.x = 0.5*(bbox[1].x + bbox[0].x);
            centroid.y = 0.5*(bbox[1].y + bbox[0].y);

        }else{
            centroid.multiply(scale).add(pos);
        }

        return {
            name: name,
            ids: ids,
            bbox: bbox,
            centroid: centroid,
        };

    }

}


ModelCollection.setModelClass('geo', GeoModel);

export default GeoModel;